import validate from "/var/www/html/node_modules/nuxt/dist/pages/runtime/validate.js";
import transitions_45global from "/var/www/html/app/middleware/transitions.global.ts";
import manifest_45route_45rule from "/var/www/html/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  transitions_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/var/www/html/app/middleware/auth.ts")
}